import { render, staticRenderFns } from "./addapp.vue?vue&type=template&id=f0d1440c&scoped=true"
import script from "./addapp.vue?vue&type=script&lang=js"
export * from "./addapp.vue?vue&type=script&lang=js"
import style0 from "./addapp.vue?vue&type=style&index=0&id=f0d1440c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d1440c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d1440c')) {
      api.createRecord('f0d1440c', component.options)
    } else {
      api.reload('f0d1440c', component.options)
    }
    module.hot.accept("./addapp.vue?vue&type=template&id=f0d1440c&scoped=true", function () {
      api.rerender('f0d1440c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/addapp.vue"
export default component.exports